/** @type {import('next-i18n-router/dist/types').Config} */
module.exports = {
  defaultLocale: "fi",
  locales: ["fi", "en", "sv"],
  localeDetector: false,
  prefixDefault: false,
  basePath: process.env.BASE_PATH ?? "",
  serverSetCookie: "never"
}
